import React from "react";
import BrandPageHeader from "./BrandPageHeader";
import BrandSections from "./BrandSections";
import { BrandDetail } from "~/common/Store/models/Brand";
import BrandNonFeaturedCategories from "./BrandNonFeaturedCategories";

const BrandPage = (props: BrandDetail) => {
  const { sections, nonFeaturedCategories } = props;
  return (
    <div className="container">
      <div id="page">
        <div id="main" className="skip-to-main-target">
          <BrandPageHeader {...props} />
          {sections && <BrandSections sections={sections} />}
          {!!nonFeaturedCategories?.length && (
            <BrandNonFeaturedCategories
              nonFeaturedCategories={nonFeaturedCategories}
              categoriesPerPage={30}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandPage;
